namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_vk_token_switch, {
		
		Switch: {
			Option: {
				'[mol_check_checked]': {
					true: {
						['$shm_hitalama_vk_token_view_avatar' as '$mol_view']: {
							outline: '2px solid var(--mol_theme_current)',
							outlineOffset: '2px',
						},
					},
				},
			},
		},
		
	} )
	
}
